import styles from './ProjectLinkItem.module.css'
import { GoTag } from "react-icons/go";
import { useLanguage } from '../contexts/LanguageContext'

function ProjectLinkItem({repoUrl, repoTitle, language}){
    // Language prop is passed from parent component
    // You could add language-specific text or formatting here if needed
    return (
        <span className={styles.ProjectLinkItemSpan}>
            <GoTag /> 
            <a  
                className={styles.ProjectLinkItemAhref} 
                href={repoUrl}  
                rel="noreferrer"   
                target="_blank"
                title={language === 'eng' ? `Open ${repoTitle}` : `Открыть ${repoTitle}`}
            >
                {repoTitle}
            </a>
        </span>
    )
}

export default ProjectLinkItem